import type { NetSuiteGetCustomersResponse } from '@vy/api-definition';
import { purge } from '@vy/utils';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../../../services/api';
import { queryKeys } from '../../../../services/query-key/query-keys';
import { useCanConnectNetSuite } from './use-can-connect-net-suite';
import type { CustomUseQueryOptions } from '../../requests-types/custom-use-query-options';

export function useNetSuiteCustomers(
  searchParam?: string,
  options?: CustomUseQueryOptions<NetSuiteGetCustomersResponse>,
) {
  const isNetSuiteActivated = useCanConnectNetSuite();

  const queryDeps = purge([searchParam]);

  return useQuery(
    queryKeys.netSuiteCustomers(...queryDeps),

    () => {
      const api = getPrivateApi();

      return api.netSuiteGetCustomers({ search: searchParam });
    },
    {
      ...options,
      enabled: isNetSuiteActivated,
    },
  );
} 